<template>
  <div class="page-item">
    <base-section-title class="p-t-24 p-l-24 p-r-24 p-b-8" title="平台公告" />
    <el-scrollbar v-if="list.length">
      <div class="content">
        <div v-for="(item, index) in list" :key="index" class="list-item">
          <div class="text1 text-ellipsis" @click="noticeHandle(item)">
            {{ item.title }}
          </div>
          <div class="text2">{{ diffTime(item.releaseTime) }}</div>
        </div>
      </div>
    </el-scrollbar>
    <el-dialog
      class="dialog"
      append-to-body
      title="平台公告详情"
      :visible.sync="dialogVisible"
      width="800px"
      :before-close="closeNotice"
    >
      <p class="detail-title">{{ currentNotice.title }}</p>
      <div class="detail-title-tip">
        <span>发布时间：{{ currentNotice.releaseTime }}</span>
      </div>
      <div class="detail-text">
        <div v-dompurify-html="currentNotice.content"></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeNotice">取 消</el-button>
        <el-button type="primary" @click="closeNotice">确 定</el-button>
      </span>
    </el-dialog>
    <el-empty v-if="!list.length" :image="noData" class="content" />
  </div>
</template>

<script>
import BaseSectionTitle from '@/components/common/BaseSectionTitle'
import { diffTime } from '@/utils/utils'
import { getArticlesListApi, getArticlesDetailApi } from '@/api/notice'
import { articleAliasDict } from '@/dictionary/notice'

export default {
  name: 'HomeNotice',

  components: {
    BaseSectionTitle
  },

  data() {
    return {
      noData: require('@/assets/images/home/Notice-no-data.png'),
      dialogVisible: false,
      currentNotice: {}, // 当前点击的消息
      list: [],
      total: 0
    }
  },

  computed: {},

  created() {
    this.getLIst()
  },

  methods: {
    diffTime,

    getLIst() {
      const params = {
        page: 1,
        size: 5,
        categoryAlias: articleAliasDict.PRODUCT_NOTICE.value
      }
      getArticlesListApi(params)
        .then(res => {
          this.list = (res.data.records || []).map(value =>
            Object.assign({}, { articleId: value.articleId }, value.articleInfo)
          )
          this.total = res.data.total || 0
        })
        .catch(err => {
          this.$message.error(err?.message || err)
        })
    },

    noticeHandle(row) {
      getArticlesDetailApi(row.articleId)
        .then(res => {
          this.currentNotice = res?.data?.articleInfo || {}
          this.dialogVisible = true
        })
        .catch(err => {
          this.$message.error(err?.message || '获取文章详情失败')
        })
    },

    closeNotice() {
      this.dialogVisible = false
    }
  }
}
</script>

<style scoped lang="scss">
.page-item {
  background: $white-color;
  margin: 8px 8px 16px 8px;
  box-sizing: border-box;
  padding: 0px;
  .content {
    height: 275px;
  }
  .list-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    height: 52px;
    margin: 0 24px;
    &:after {
      display: block;
      position: absolute;
      left: 0;
      bottom: 0;
      background: $info-fourth-color;
      height: 1px;
      width: 100%;
      content: '';
    }
    &:nth-last-child(1)::after {
      display: none;
    }
    .text1 {
      font-size: 14px;
      color: $text-color;
      cursor: pointer;
      &:hover {
        color: $primary-color;
      }
    }
    .text2 {
      width: 200px;
      text-align: right;
      font-size: 14px;
      color: $third-text-color;
    }
  }
}
p {
  margin-block-start: 0em;
  margin-block-end: 0em;
}
.detail-title {
  color: $text-color;
  font-size: pixel-to-rem($n: 22);
}
.detail-title-tip {
  color: $second-text-color;
  font-size: pixel-to-rem($n: 18);
  padding: pixel-to-rem($n: 30) 0;
  width: 100%;
  border-bottom: 1px solid $border-color;
}
.detail-text {
  color: $second-text-color;
  font-size: pixel-to-rem($n: 18);
  margin-top: pixel-to-rem($n: 30);
  a {
    color: $primary-color;
    margin-left: pixel-to-rem($n: 10);
    cursor: pointer;
    &:hover {
      color: $deep-primary-color;
    }
  }
}
::v-deep .el-table__row {
  cursor: pointer;
}
</style>
